export default "__VITE_ASSET__qgsMmgKj__"